import React from 'react';

import PropTypes from 'prop-types';

export default function GhostSlots({ slots }) {
  return (
    <>
      {slots.map(({ height, top }) => (
        <div
          className='tw-pointer-events-none tw-absolute tw-z-[-1] tw-w-full tw-border-1 tw-border-solid tw-border-blue-100 tw-bg-blue-025'
          key={top}
          style={{ height, top }}
        />
      ))}
    </>
  );
}

GhostSlots.propTypes = {
  slots: PropTypes.arrayOf(
    PropTypes.exact({
      height: PropTypes.number.isRequired,
      top: PropTypes.number.isRequired,
    }),
  ).isRequired,
};
